<style src="../assets/style.css">
</style>
<template>
    <div class="product_list">
        <div class="banner" v-if="consult.page_image">
            <div class="banner__img consulting-banner__img" :style="{ 'background-image': 'url(' + consult.page_image + ')' }"></div>
        </div>
        <div class="consulting">
            <div class="row">
                <div class="col-12" :class="{'col-md-7': consult.media__content }">
                    <h1 class="consulting__title"> {{ consult.title }} </h1>
                    <div class="consulting__content" v-html="consult.content"></div>
                </div>
                <div class="col-12 col-md-5 consulting__video-container" v-if="consult.media_content">
                    <video autoplay controls="true" class="consulting__video" :src="consult.media_content"></video>
                </div>
            </div>

            <app-benefits v-if="benefits.length > 0" :benefits="benefits"></app-benefits>

            <app-call-to-action></app-call-to-action>
        </div>
        <div class="partners" v-if="consult.partenerList.length > 0 || testimonials.length > 0">
            <h2 class="partners__title">Parteneri & Testimoniale</h2>
            <app-partners v-if="consult.partenerList.length > 0" :partners="consult.partenerList"></app-partners>
            <app-testimonials v-if="testimonials.length > 0" :testimonials="testimonials"></app-testimonials>
        </div>
    </div>
</template>

<script>
    import appCallToAction from './CallToAction';
    import appBenefits from './Shared/Benefits';
    import appPartners from './Shared/Partners';
    import appTestimonials from './Shared/Testimonials';
    import GlobalService from './../services/Global';

    export default {
        data() {
            return {
                consult: {
                    article: {
                    },
                    media_content: null,
                    partenerList: []
                },
                benefits: [],
                testimonials: []
            }
        },
        components: {
            appCallToAction,
            appBenefits,
            appPartners,
            appTestimonials
        },
        created () {
            this.getConsulting()
        },
        methods: {
            getConsulting () {
                window.$('.footer').removeClass('footer-delete')
                this.$http.get(`/pages/${this.$route.path.replace('/', '')}`)
                .then(response => {
                    this.consult = response.data
                    localStorage.setItem('formId', this.consult.call_to_action_form)

                    this.testimonials = GlobalService.checkForBenefitsOrTestimonials(this.consult.article, 'testimonials')
                    this.benefits = GlobalService.checkForBenefitsOrTestimonials(this.consult.article, 'benefits')

                    GlobalService.initializeCarousel()
                    GlobalService.initializeSecondCarousel()
                    this.consult.article = GlobalService.removeBenefitsAndTestimonials(this.consult.article)
                })
                .catch(e => {
                    console.log(e)
                    this.$router.push('/404')
                })
            }
        }
    }
</script>